import _ from 'underscore';
import { UAPCroppingType, UAPImageExpansionType } from '@bingads-webui-campaign-react/unified-ad-preview-library-util';
import { AspectRatiosForDisplayAds } from './aspect-ratios-for-display-ads';
import { AspectRatiosForLinkedInAds } from './aspect-ratios-for-linkedin-ads';

const constants = {
  brandkitMinSize: [128, 128],
  aspectRatios: {
    Image191x100: {
      aspectRatio: 1.91,
      type: 'Image191x100',
      associationType: 'LandscapeImageMedia',
      stringKey: 'ImageExperience_Image_Ratio_191x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_191x100',
      previewTypeString: _TL_('MSN feed'),
      imagePreviewHeight: 200,
      previewWidth: '191px',
      previewHeight: '100px',
      simplifiedType: 'Image191x100',
      isRequired: true,
      minimumRequirements: 1,
      minSize: [703, 368],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'audience-network-wide',
        showShortHeadline: true,
        showDescription: true,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
    },
    Image178x100: {
      aspectRatio: 1.78,
      type: 'Image178x100',
      associationType: 'ImageMedia178X100',
      stringKey: 'ImageExperience_Image_Ratio_178x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_178x100',
      previewTypeString: _TL_('Microsoft Edge single carousel'),
      imagePreviewHeight: 350,
      minimumRequirements: 0,
      minSize: [624, 350],
      previewSettings: {
        previewContentClassName: 'edge-single-carousel',
        showShortHeadline: true,
        showDescription: false,
        showGradient: true,
      },
      isLogo: false,
    },
    Image172x100: {
      aspectRatio: 1.72,
      type: 'Image172x100',
      associationType: 'ImageMedia172X100',
      stringKey: 'ImageExperience_Image_Ratio_172x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_172x100',
      previewTypeString: _TL_('Microsoft Edge medium headline'),
      imagePreviewHeight: 174,
      minimumRequirements: 0,
      minSize: [300, 174],
      previewSettings: {
        previewContentClassName: 'edge-medium-headline',
        showShortHeadline: false,
        showLongHeadline: true,
        showDescription: false,
        showGradient: true,
      },
      isLogo: false,
    },
    Image169x100: {
      aspectRatio: 1.69,
      type: 'Image169x100',
      associationType: 'ImageMedia169X100',
      stringKey: 'ImageExperience_Image_Ratio_169x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_169x100',
      previewTypeString: _TL_('MSN carousel'),
      imagePreviewHeight: 368,
      minimumRequirements: 0,
      minSize: [622, 368],
      previewSettings: {
        previewContentClassName: 'msn-single-carousel',
        showShortHeadline: false,
        showLongHeadline: true,
        showDescription: false,
        showGradient: true,
      },
      isLogo: false,
    },
    Image155x100: {
      aspectRatio: 1.55,
      type: 'Image155x100',
      associationType: 'ImageMedia155X100',
      stringKey: 'ImageExperience_Image_Ratio_155x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_155x100',
      previewTypeString: _TL_('MSN medium headline'),
      imagePreviewHeight: 194,
      minimumRequirements: 0,
      minSize: [300, 194],
      previewSettings: {
        previewContentClassName: 'msn-medium-headline',
        showShortHeadline: false,
        showLongHeadline: true,
        showDescription: false,
      },
      isLogo: false,
    },
    Image150x100: {
      aspectRatio: 1.50,
      type: 'Image150x100',
      associationType: 'ImageMedia15X10',
      stringKey: 'ImageExperience_Image_Ratio_150x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_150x100',
      previewTypeString: _TL_('MSN in-article ad'),
      imagePreviewHeight: 200,
      minimumRequirements: 0,
      minSize: [300, 200],
      previewSettings: {
        previewContentClassName: 'msn-in-article',
        showShortHeadline: true,
        showDescription: true,
      },
      isLogo: false,
    },
    Image133x100: {
      aspectRatio: 1.33,
      type: 'Image133x100',
      associationType: 'ImageMedia133X100',
      stringKey: 'ImageExperience_Image_Ratio_133x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_133x100',
      previewTypeString: _TL_('MSN small headline'),
      imagePreviewHeight: 75,
      minimumRequirements: 0,
      minSize: [100, 75],
      previewSettings: {
        previewContentClassName: 'msn-small-headline',
        showShortHeadline: true,
        showDescription: false,
      },
      isLogo: false,
    },
    Image1x1: {
      aspectRatio: 1,
      type: 'Image1x1',
      associationType: 'SquareImageMedia',
      stringKey: 'ImageExperience_Image_Ratio_1x1',
      previewTypeStringKey: 'ImageExperience_Preview_Type_1x1',
      previewTypeString: _TL_('MSN square image'),
      imagePreviewHeight: 75,
      previewWidth: '200px',
      previewHeight: '200px',
      simplifiedType: 'Image1x1',
      isRequired: true,
      minimumRequirements: 0,
      minSize: [300, 300],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'audience-network-square-image',
        showShortHeadline: true,
        showLongHeadline: false,
        showDescription: false,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
    },
    Image93x100: {
      aspectRatio: 0.93,
      type: 'Image93x100',
      associationType: 'ImageMedia93X100',
      stringKey: 'ImageExperience_Image_Ratio_93x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_93x100',
      previewTypeString: _TL_('MSN double carousel'),
      imagePreviewHeight: 333,
      minimumRequirements: 0,
      minSize: [311, 333],
      previewSettings: {
        previewContentClassName: 'msn-double-carousel',
        showShortHeadline: true,
        showLongHeadline: false,
        showDescription: false,
        showGradient: true,
      },
      isLogo: false,
    },
  },
  aspectRatiosForNewMSANBoost: {
    Image57x100: {
      aspectRatio: 0.57,
      type: 'Image57x100',
      associationType: 'ImageMedia57X100',
      stringKey: 'ImageExperience_Image_Ratio_57x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_57x100',
      previewTypeString: _TL_('Spotlight Portrait'),
      imagePreviewHeight: 391,
      minimumRequirements: 0,
      minSize: [220, 391],
      previewSettings: {
        previewContentClassName: 'boost-spotlight-portrait-57',
        showLongHeadline: false,
        showDescription: false,
        showAction: false,
        showBusinessName: false,
      },
    },
    Image320x100: {
      aspectRatio: 3.20,
      type: 'Image320x100',
      associationType: 'ImageMedia320X100',
      stringKey: 'ImageExperience_Image_Ratio_320x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_320x100',
      previewTypeString: _TL_('Microsoft Plus'),
      imagePreviewHeight: 100,
      minimumRequirements: 0,
      minSize: [320, 100],
      previewSettings: {
        previewContentClassName: 'boost-ad-preview-320',
        showLongHeadline: true,
        showDescription: false,
        showAction: true,
        showBusinessName: false,
      },
    },
  },
  aspectRatiosForMMAV2: {
    OriginalImage: {
      aspectRatio: 1.91, // this is just a placeholder since we will not show original image in UI.
      type: 'OriginalImage',
      associationType: 'OriginalImage',
      stringKey: 'ImageExperience_Image_Ratio_ImageOriginal',
      previewTypeStringKey: 'ImageExperience_Preview_Type_ImageOriginal',
      previewTypeString: _TL_('Original image'),
      imagePreviewHeight: 200,
      previewWidth: '380px',
      previewHeight: '200px',
      isRequired: true,
      minimumRequirements: 1,
      minSize: [703, 368],
      previewSettings: {
        previewContentClassName: 'original-image',
        showShortHeadline: true,
        showDescription: true,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
      shouldIgnoreCropSetting: true,
    },
    Image201x100: {
      aspectRatio: 2.01,
      type: 'Image201x100',
      associationType: 'ImageMedia201X100',
      stringKey: 'ImageExperience_Image_Ratio_201x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_201x100',
      previewTypeString: _TL_('Microsoft Edge carousel'),
      imagePreviewHeight: 304,
      minimumRequirements: 0,
      minSize: [612, 304],
      previewSettings: {
        previewContentClassName: 'edge-carousel ',
        showShortHeadline: true,
        showDescription: false,
        showGradient: true,
      },
      isLogo: false,
    },
    Image200x100: {
      aspectRatio: 2,
      type: 'Image200x100',
      associationType: 'ImageMedia200X100',
      stringKey: 'ImageExperience_Image_Ratio_200x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_200x100',
      previewTypeString: _TL_('MSN banner'),
      imagePreviewHeight: 90,
      minimumRequirements: 0,
      minSize: [200, 100],
      previewSettings: {
        previewContentClassName: 'audience-network-banner ',
        showShortHeadline: true,
        showDescription: false,
        showGradient: true,
      },
      isLogo: false,
    },
    Image191x100: {
      aspectRatio: 1.91,
      type: 'Image191x100',
      associationType: 'LandscapeImageMedia',
      stringKey: 'ImageExperience_Image_Ratio_191x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_191x100_V2',
      previewTypeString: _TL_('MSN feed'),
      imagePreviewHeight: 157,
      minimumRequirements: 0,
      minSize: [300, 157],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'audience-network-wide-v2',
        showShortHeadline: true,
        showDescription: true,
        showGradient: true,
        showAdsIcon: true,
      },
      isLogo: false,
    },
    Image169x100: {
      aspectRatio: 1.69,
      type: 'Image169x100',
      associationType: 'ImageMedia169X100',
      stringKey: 'ImageExperience_Image_Ratio_169x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_169x100_V2',
      previewTypeString: _TL_('MSN carousel'),
      imagePreviewHeight: 372,
      minimumRequirements: 0,
      minSize: [628, 372],
      previewSettings: {
        previewContentClassName: 'msn-single-carousel-v2',
        showShortHeadline: false,
        showLongHeadline: true,
        showDescription: false,
        showGradient: true,
        showAdsIcon: true,
      },
      isLogo: false,
    },
    Image153x100: {
      aspectRatio: 1.53,
      type: 'Image153x100',
      associationType: 'ImageMedia153X100',
      stringKey: 'ImageExperience_Image_Ratio_153x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_153x100',
      previewTypeString: _TL_('MSN partner stripe'),
      imagePreviewHeight: 197,
      minimumRequirements: 0,
      minSize: [306, 200],
      previewSettings: {
        previewContentClassName: 'msn-partner-stripe',
        showShortHeadline: false,
        showLongHeadline: true,
        showDescription: false,
      },
      isLogo: false,
    },
    Image124x100: {
      aspectRatio: 1.24,
      type: 'Image124x100',
      associationType: 'ImageMedia124X100',
      stringKey: 'ImageExperience_Image_Ratio_124x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_124x100',
      previewTypeString: _TL_('MSN Restoday'),
      imagePreviewHeight: 84,
      minimumRequirements: 0,
      minSize: [104, 84],
      previewSettings: {
        previewContentClassName: 'msn-restoday',
        showShortHeadline: true,
        showDescription: false,
        showAdsIcon: true,
      },
      isLogo: false,
    },
    Image120x100: {
      aspectRatio: 1.2,
      type: 'Image120x100',
      associationType: 'ImageMedia120X100',
      stringKey: 'ImageExperience_Image_Ratio_120x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_120x100',
      previewTypeString: _TL_('MSN rectangle image'),
      imagePreviewHeight: 250,
      minimumRequirements: 0,
      minSize: [300, 250],
      previewSettings: {
        previewContentClassName: 'audience-network-rectangle',
        showShortHeadline: true,
        showDescription: false,
        showGradient: true,
      },
      isLogo: false,
    },
    Image1x1: {
      aspectRatio: 1,
      type: 'Image1x1',
      associationType: 'SquareImageMedia',
      stringKey: 'ImageExperience_Image_Ratio_1x1',
      previewTypeStringKey: 'ImageExperience_Preview_Type_1x1_V2',
      previewTypeString: _TL_('Edge Mobile'),
      imagePreviewHeight: 75,
      previewWidth: '150',
      previewHeight: '150',
      simplifiedType: 'Image1x1',
      isRequired: true,
      minimumRequirements: 0,
      minSize: [114, 114],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'audience-network-square-image-v2',
        showShortHeadline: true,
        showLongHeadline: false,
        showDescription: false,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
    },
  },
  aspectRatiosForDisplayAds: AspectRatiosForDisplayAds,
  aspectRatiosForBoostPortrait: {
    Image1x2: {
      aspectRatio: 0.5,
      type: 'Image1x2',
      associationType: 'ImageMedia1x2',
      stringKey: 'ImageExperience_Image_Ratio_1x2',
      previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_1x2',
      previewTypeString: _TL_('Vertical image'),
      imagePreviewHeight: 400,
      previewWidth: '200px',
      previewHeight: '400px',
      simplifiedType: 'Image1x2',
      isRequired: true,
      minimumRequirements: 0,
      minSize: [470, 940],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'boost-ad-portrait-image',
        showShortHeadline: true,
        showLongHeadline: false,
        showDescription: false,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
      isPortrait: true,
    },
  },
  aspectRatiosForBoost200x100: {
    Image200x100: {
      aspectRatio: 2,
      type: 'Image200x100',
      associationType: 'ImageMedia200X100',
      stringKey: 'ImageExperience_Image_Ratio_200x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_200x100_Boost',
      previewTypeString: _TL_('Hero Image Carousel 200x100'),
      imagePreviewHeight: 320,
      minimumRequirements: 0,
      minSize: [200, 100],
      previewSettings: {
        previewContentClassName: 'boost-ad-preview-200',
        showLongHeadline: true,
        showDescription: true,
        showAction: true,
        showBusinessName: false,
      },
    },
  },
  aspectRatiosForBoostNewSupport: {
    Image122x100: {
      aspectRatio: 1.225,
      type: 'Image122x100',
      associationType: 'ImageMedia122X100',
      stringKey: 'ImageExperience_Image_Ratio_122x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_122x100',
      previewTypeString: _TL_('Hero Image Carousel 122x100'),
      imagePreviewHeight: 320,
      minimumRequirements: 0,
      minSize: [450, 368],
      previewSettings: {
        previewContentClassName: 'boost-ad-preview-122',
        showLongHeadline: true,
        showDescription: true,
        showAction: true,
        showBusinessName: false,
      },
    },
    Image159x100: {
      aspectRatio: 1.59,
      type: 'Image159x100',
      associationType: 'ImageMedia159X100',
      stringKey: 'ImageExperience_Image_Ratio_159x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_159x100',
      previewTypeString: _TL_('Hero Image Carousel 159x100'),
      imagePreviewHeight: 320,
      minimumRequirements: 0,
      minSize: [585, 368],
      previewSettings: {
        previewContentClassName: 'boost-ad-preview-159',
        showLongHeadline: true,
        showDescription: true,
        showAction: true,
        showBusinessName: false,
      },
    },
    Image180x100: {
      aspectRatio: 1.805,
      type: 'Image180x100',
      associationType: 'ImageMedia180X100',
      stringKey: 'ImageExperience_Image_Ratio_180x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_180x100',
      previewTypeString: _TL_('Hero Image Carousel 180x100'),
      imagePreviewHeight: 320,
      minimumRequirements: 0,
      minSize: [664, 368],
      previewSettings: {
        previewContentClassName: 'boost-ad-preview-180',
        showLongHeadline: true,
        showDescription: true,
        showAction: true,
        showBusinessName: false,
      },
    },
    Image233x100: {
      aspectRatio: 2.33,
      type: 'Image233x100',
      associationType: 'ImageMedia233X100',
      stringKey: 'ImageExperience_Image_Ratio_233x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_233x100',
      previewTypeString: _TL_('Hero Image Carousel 233x100'),
      imagePreviewHeight: 250,
      minimumRequirements: 0,
      minSize: [703, 301],
      previewSettings: {
        previewContentClassName: 'boost-ad-preview-233',
        showLongHeadline: true,
        showDescription: true,
        showAction: true,
        showBusinessName: false,
      },
    },
    Image320x100: {
      aspectRatio: 3.20,
      type: 'Image320x100',
      associationType: 'ImageMedia320X100',
      stringKey: 'ImageExperience_Image_Ratio_320x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_320x100',
      previewTypeString: _TL_('Hero Image Carousel 320x100'),
      imagePreviewHeight: 180,
      minimumRequirements: 0,
      minSize: [703, 219],
      previewSettings: {
        previewContentClassName: 'boost-ad-preview-320',
        showLongHeadline: true,
        showDescription: true,
        showAction: true,
        showBusinessName: false,
      },
    },
    Image57x100: {
      aspectRatio: 0.57,
      type: 'Image57x100',
      associationType: 'ImageMedia57X100',
      stringKey: 'ImageExperience_Image_Ratio_57x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_57x100',
      previewTypeString: _TL_('Hero Image Carousel 57x100'),
      imagePreviewHeight: 320,
      minimumRequirements: 0,
      minSize: [210, 368],
      previewSettings: {
        previewContentClassName: 'boost-ad-preview-57',
        showLongHeadline: true,
        showDescription: true,
        showAction: true,
        showBusinessName: false,
      },
    },
  },
  videoAspectRatios: {
    VideoMedia16X9: {
      ratio: 16 / 9,
      text: '16 : 9',
      stringKey: 'ImageExperience_Video_Ratio_16x9',
      cropSetting: {
        minSize: {
          width: 160,
          height: 90,
        },
      },
      thumbnailCropSetting: {
        minSize: [224, 126],
      },
    },
    VideoMedia5X4: {
      ratio: 1.25,
      text: '5 : 4',
      stringKey: 'ImageExperience_Video_Ratio_5x4',
      cropSetting: {
        minSize: {
          width: 100,
          height: 80,
        },
      },
      thumbnailCropSetting: {
        minSize: [150, 120],
      },
    },
    VideoMedia1X1: {
      ratio: 1,
      text: '1 : 1',
      stringKey: 'ImageExperience_Video_Ratio_1x1',
      cropSetting: {
        minSize: {
          width: 100,
          height: 100,
        },
      },
      thumbnailCropSetting: {
        minSize: [120, 120],
      },
    },
    VideoMedia4X5: {
      ratio: 0.8,
      text: '4 : 5',
      stringKey: 'ImageExperience_Video_Ratio_4x5',
      cropSetting: {
        minSize: {
          width: 80,
          height: 100,
        },
      },
      thumbnailCropSetting: {
        minSize: [120, 150],
      },
    },
    VideoMedia9X16: {
      ratio: 9 / 16,
      text: '9 : 16',
      stringKey: 'ImageExperience_Video_Ratio_9x16',
      cropSetting: {
        minCropSize: {
          width: 90,
          height: 160,
        },
      },
      thumbnailCropSetting: {
        minSize: [126, 224],
      },
    },
  },
  aspectRatiosForAppCampaign: {
    ImagePRONG: {
      aspectRatio: 300 / 304,
      type: 'ImagePRONG',
      associationType: 'ImagePRONG',
      stringKey: 'ImageExperience_Image_Ratio_1x1',
      previewTypeStringKey: 'ImageExperience_Preview_Type_1x1',
      previewTypeString: _TL_('MSN square image'),
      imagePreviewHeight: 75,
      previewWidth: '200px',
      previewHeight: '200px',
      simplifiedType: 'ImagePRONG',
      isRequired: false,
      minimumRequirements: 0,
      minSize: [300, 304],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'audience-network-square-image',
        // showShortHeadline: true,
        // showLongHeadline: false,
        // showDescription: false,
        // showAdditionalDisclaimer: true,
      },
      isLogo: false,
    },
    ImageSPOTLIGHT: {
      aspectRatio: 1.78,
      type: 'ImageSPOTLIGHT',
      associationType: 'ImageSPOTLIGHT',
      stringKey: 'ImageExperience_Image_Ratio_178x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_178x100',
      previewTypeString: _TL_('Microsoft Edge single carousel'),
      imagePreviewHeight: 350,
      minimumRequirements: 0,
      minSize: [1920, 1080],
      previewSettings: {
        // previewContentClassName: 'edge-single-carousel',
        // showShortHeadline: true,
        // showDescription: false,
        // showGradient: true,
      },
      isLogo: false,
    },
    TransparentLogo: {
      aspectRatio: 1,
      type: 'TransparentLogo',
      associationType: 'TransparentLogo',
      stringKey: 'ImageExperience_Image_Ratio_1x1',
      previewTypeStringKey: 'ImageExperience_Preview_Type_178x100',
      previewTypeString: _TL_('Microsoft Edge single carousel'),
      imagePreviewHeight: 350,
      minimumRequirements: 0,
      minSize: [300, 300],
      maxSize: [1000, 1000],
      previewSettings: {
        // previewContentClassName: 'edge-single-carousel',
        // showShortHeadline: true,
        // showDescription: false,
        // showGradient: true,
      },
      isLogo: false,
    },
  },
  aspectRatiosForLinkedInAds: AspectRatiosForLinkedInAds,
  videoPreviewsSettings: [
    {
      type: '16X9-Homepage',
      videoType: 'VideoMedia16X9',
      text: '16 : 9',
      stringKey: 'ImageExperience_Video_Ratio_16x9',
      previewContainerHeight: 360,
      previewContainerWidth: 640,
      hideTextWhenPlay: true,
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: false,
      showAdditionalDisclaimer: false,
      showProgressText: true,
      className: 'preview-16-9-homepage',
    },
    {
      type: '16X9-Infopane',
      videoType: 'VideoMedia16X9',
      text: '16 : 9',
      stringKey: 'ImageExperience_Video_Ratio_16x9',
      previewContainerHeight: 360,
      previewContainerWidth: 640,
      hideTextWhenPlay: true,
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: false,
      showAdditionalDisclaimer: false,
      showProgressText: true,
      className: 'preview-16-9-infopane',
    },
    {
      type: '16X9-InArticleAd',
      videoType: 'VideoMedia16X9',
      text: '16 : 9',
      stringKey: 'ImageExperience_Video_Ratio_16x9',
      previewContainerHeight: 296,
      previewContainerWidth: 318,
      hideTextWhenPlay: false,
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: false,
      showAdditionalDisclaimer: false,
      showProgressText: false,
      className: 'preview-16-9-inarticlead',
    },
  ],
  videoPreviewDefaultWidth: 640,
  videoPreviewDefaultHeight: 300,
  resizeImageHeightInList: 80,
  sortBySelections: {
    recentUpload: {
      id: 1,
      enum: 'recentUpload',
      stringKey: 'ImageExperience_SortBy_RecentUpload',
      query: '$orderby=UploadedTime desc',
    },
    imageText: {
      id: 2,
      enum: 'imageText',
      stringKey: 'ImageExperience_SortBy_ImageText',
      query: '$orderby=Text asc',
    },
  },
  videoSortBySelections: {
    recentUpload: {
      id: 1,
      enum: 'recentUpload',
      stringKey: 'ImageExperience_Sort_Recent_Upload',
      query: '$orderby=UploadedTime desc',
      edmDefinition: { UploadedTime: -1 },
    },
    description: {
      id: 2,
      enum: 'description',
      stringKey: 'ImageExperience_Sort_Video_Text',
      query: '$orderby=Text asc',
      edmDefinition: { Text: 1 },
    },
  },
  imageTypesWithOrder: [
    'Image191x100',
    'Image178x100',
    'Image172x100',
    'Image169x100',
    'Image155x100',
    'Image150x100',
    'Image133x100',
    'Image1x1',
    'Image93x100',
  ],
  videoTypesWithOrder: [
    'VideoMedia16X9',
    'VideoMedia5X4',
    'VideoMedia1X1',
    'VideoMedia4X5',
    'VideoMedia9X16',
  ],
  videoTypeToThumbnailType: {
    VideoMedia16X9: 'VideoMedia16X9Thumbnail',
    VideoMedia5X4: 'VideoMedia5X4Thumbnail',
    VideoMedia1X1: 'VideoMedia1X1Thumbnail',
    VideoMedia4X5: 'VideoMedia4X5Thumbnail',
    VideoMedia9X16: 'VideoMedia9X16Thumbnail',
  },
  subTypeToType: {
    // notice that 'X' is in capital
    ImageMedia4X1: 'Image4x1',
    LandscapeImageMedia: 'Image191x100',
    ImageMedia178X100: 'Image178x100',
    ImageMedia172X100: 'Image172x100',
    ImageMedia169X100: 'Image169x100',
    ImageMedia155X100: 'Image155x100',
    ImageMedia15X10: 'Image150x100',
    ImageMedia133X100: 'Image133x100',
    SquareImageMedia: 'Image1x1',
    ImageMedia93X100: 'Image93x100',
    ImageMedia1X2: 'Image1x2',
    LandscapeLogoMedia: 'Image4x1',
    SquareLogoMedia: 'Image1x1',
    OriginalImage: 'OriginalImage',
    ImageMedia201X100: 'Image201x100',
    ImageMedia200X100: 'Image200x100',
    ImageMedia153X100: 'Image153x100',
    ImageMedia124X100: 'Image124x100',
    ImageMedia120X100: 'Image120x100',
    ImageMedia122X100: 'Image122x100',
    ImageMedia159X100: 'Image159x100',
    ImageMedia180X100: 'Image180x100',
    ImageMedia233X100: 'Image233x100',
    ImageMedia320X100: 'Image320x100',
    ImageMedia57X100: 'Image57x100',
    ImagePRONG: 'ImagePRONG',
    ImageSPOTLIGHT: 'ImageSPOTLIGHT',
    TransparentLogo: 'TransparentLogo',
    PortraitImageMedia: 'Image4x5',
  },
  pageSize: 12,
  imageAdExtSettings: {
    MobileMultiImage: {
      previewContentClassName: 'mobile-multi-img',
      imagePreviewHeight: 310,
      previewTypeStringKey: 'ImageExperience_Preview_Type_MobileMulti',
      previewTypeString: _TL_('Bing mobile multi-image extension'),
    },
    BingDesktopImage: {
      previewContentClassName: 'bing-desktop-img',
      imagePreviewHeight: 100,
      previewTypeStringKey: 'ImageExperience_Preview_Type_BingDeskMulti',
      previewTypeString: _TL_('Bing desktop multi-image extension'),
    },
    BingSingleImage: {
      previewTypeStringKey: 'ImageExperience_Preview_Type_BingSingleImage',
      previewTypeString: _TL_('Bing desktop single-image extension'),
      imagePreviewHeight: 45,
      previewSettings: {
        previewContentClassName: 'bing-single-image',
        showShortHeadline: false,
        showLongHeadline: true,
        showDescription: true,
        showBusinessName: false,
        showUrl: true,
      },
    },
  },
};

constants.GenericImage = {
  minWidth: 128,
  minHeight: 128,
};

constants.DefaultImageMinimumSize = [703, 368];

constants.getMinimumSizeForImage = ({
  type,
  isMultimediaAd = false,
  imageOption = constants.defaultImageOption,
  isCombinedMsanAndMmaAspectRatios = false,
  isMMAV2Enabled = false,
  isDisplayAds = false,
  isPortraitImage = false,
  isBoost200x100ImageEnabled = false,
  isBoostNewAspectRatioSupportEnabled = false,
  isStoreAppProng = false,
  isStoreAppSpotLight = false,
  isStoreAppTransparentLogo = false,
  isLinkedInAd = false,
  isUnifiedAppCampaignWindowsStore = false,
  isPMaxAspectRatiosV2Enabled = false,
  isBrandKit = false,
  isNewMSANBoostEnabled = false,
} = {}) => {
  // if type is undefined or null , then it is for all aspect ratio minimum size.
  // if type is not undefined or not null, then it is to return minimum size for a certain aspect ratio.

  if (isLinkedInAd && !type) {
    return [0, 0];
  }

  if (isBrandKit) {
    return constants.brandkitMinSize;
  }

  if (isStoreAppProng) {
    return constants.aspectRatiosForAppCampaign.ImagePRONG.minSize;
  }

  if (isStoreAppSpotLight) {
    return constants.aspectRatiosForAppCampaign.ImageSPOTLIGHT.minSize;
  }

  if (isStoreAppTransparentLogo) {
    return constants.aspectRatiosForAppCampaign.TransparentLogo.minSize;
  }

  if (isUnifiedAppCampaignWindowsStore) {
    return constants.aspectRatiosForAppCampaign.ImagePRONG.minSize;
  }

  if (isMMAV2Enabled && !type && imageOption !== constants.imageOptionKeys.Logo) {
    // we want to return the minimum size for the default image (703x368)
    // but in V2 images, 1.69 aspecr ratio is 703x372, which is a corner case
    // hard code here to return 703x368
    return constants.DefaultImageMinimumSize;
  }

  if (isCombinedMsanAndMmaAspectRatios && !type) {
    // Minimum uploaded image dimensions for PMax
    return constants.DefaultImageMinimumSize;
  }

  const aspectRatios = constants.getAspectRatios({
    imageOption,
    isMultimediaAd,
    isCombinedMsanAndMmaAspectRatios,
    isMMAV2Enabled,
    isDisplayAds,
    isPortraitImage,
    isNewMSANBoostEnabled,
    isBoost200x100ImageEnabled,
    isBoostNewAspectRatioSupportEnabled,
    isLinkedInAd,
    isUnifiedAppCampaignWindowsStore,
    isPMaxAspectRatiosV2Enabled,
  });

  if (type) {
    return aspectRatios[type].minSize;
  } else if (isMultimediaAd) {
    return [constants.GenericImage.minWidth, constants.GenericImage.minHeight];
  }

  if (isDisplayAds || imageOption === constants.imageOptionKeys.Logo) {
    // pick the smallest size for display ads and for logo, since logo can be square or landscape.
    return _.reduce(aspectRatios, (memo, val) => [
      memo[0] < val.minSize[0] ? memo[0] : val.minSize[0],
      memo[1] < val.minSize[1] ? memo[1] : val.minSize[1],
    ], [Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER]);
  }

  return _.reduce(aspectRatios, (memo, val) => [
    memo[0] > val.minSize[0] ? memo[0] : val.minSize[0],
    memo[1] > val.minSize[1] ? memo[1] : val.minSize[1],
  ], [0, 0]);
};

constants.getMinSizeForRequiredRatios = (isMultimediaAd) => {
  const aspectRatios = isMultimediaAd ?
    constants.getMmaAspectRatios() :
    constants.aspectRatios;

  const requiredRatios = _.filter(aspectRatios, ratio => ratio.minimumRequirements > 0);

  return _.reduce(requiredRatios, (memo, val) => [
    memo[0] > val.minSize[0] ? memo[0] : val.minSize[0],
    memo[1] > val.minSize[1] ? memo[1] : val.minSize[1],
  ], [0, 0]);
};

constants.getMinSizeForAllRequiredRatios = () => {
  const minSizeForMMA = constants.getMinSizeForRequiredRatios(true);
  const minSizeForOther = constants.getMinSizeForRequiredRatios(false);

  return [
    Math.max(minSizeForMMA[0], minSizeForOther[0]),
    Math.max(minSizeForMMA[1], minSizeForOther[1]),
  ];
};

constants.getImageTypesWithOrder = (
  isMultimediaAd = false,
  isCombinedMsanAndMmaAspectRatios = false,
  isStoreAppProng = false,
  isStoreAppSpotLight = false,
  isStoreAppTransparentLogo = false,
  isLinkedInAd = false,
  isPMaxAspectRatiosV2Enabled = false,
  isRefreshedExtensionRatiosEnabled = false
) => {
  if (isLinkedInAd) {
    return [
      'Image191x100',
      'Image1x1',
      'Image4x5',
    ];
  }

  if (isStoreAppProng) {
    return [
      'ImagePRONG',
    ];
  }
  if (isStoreAppSpotLight) {
    return [
      'ImageSPOTLIGHT',
    ];
  }
  if (isStoreAppTransparentLogo) {
    return [
      'TransparentLogo',
    ];
  }
  if (isCombinedMsanAndMmaAspectRatios) {
    return isPMaxAspectRatiosV2Enabled
      ? [
        'Image4x1',
        'Image191x100',
        'Image201x100',
        'Image169x100',
        'Image153x100',
        'Image124x100',
        'Image1x1',
        'Image1x2',
      ]
      : [
        'Image4x1',
        'Image191x100',
        'Image178x100',
        'Image150x100',
        'Image133x100',
        'Image1x1',
        'Image1x2',
      ];
  }

  if (isMultimediaAd) {
    return [
      'Image4x1',
      'Image191x100',
      'Image1x1',
      'Image1x2',
    ];
  }

  if (isRefreshedExtensionRatiosEnabled) {
    return [
      'Image191x100',
      'Image178x100',
      'Image133x100',
      'Image169x100',
      'Image1x1',
      'Image155x100',
      'Image172x100',
      'Image150x100',
      'Image93x100',
    ];
  }

  return constants.imageTypesWithOrder;
};

constants.getDefaultRatio = (width, height, aspectRatios) =>
  _.chain(aspectRatios)
    .filter(ratio => width >= ratio.minSize[0] && height >= ratio.minSize[1])
    .sortBy(ratio => Math.abs(ratio.aspectRatio - (width / height)))
    .first()
    .value();

constants.logoSubtypes = {
  LandscapeLogoMedia: 'Image4x1',
  SquareLogoMedia: 'Image1x1',
};

constants.portraitSubtypes = {
  ImageMedia1X2: 'Image1x2',
};

const logoAspectRatios = {
  Image4x1: {
    aspectRatio: 4,
    type: 'Image4x1',
    associationType: 'LandscapeLogoMedia',
    stringKey: 'ImageExperience_Image_Ratio_4x1',
    previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_4x1',
    imagePreviewHeight: 152,
    previewWidth: '608px',
    previewHeight: '152px',
    simplifiedType: 'Image4x1',
    isRequired: true,
    minimumRequirements: 0,
    minSize: [512, 128],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'multimedia-ad-wide-image',
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: true,
  },
  Image1x1: {
    aspectRatio: 1,
    type: 'Image1x1',
    associationType: 'SquareLogoMedia',
    stringKey: 'ImageExperience_Image_Ratio_1x1',
    previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_1x1',
    imagePreviewHeight: 400,
    previewWidth: '400px',
    previewHeight: '400px',
    simplifiedType: 'Image1x1',
    isRequired: true,
    minimumRequirements: 1,
    minSize: [128, 128],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'multimedia-ad-square-image',
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: true,
  },
};

constants.getMmaAspectRatios = (imageOption) => {
  if (imageOption === constants.imageOptionKeys.Logo) {
    return logoAspectRatios;
  }
  return {
    Image191x100: {
      aspectRatio: 1.91,
      type: 'Image191x100',
      associationType: 'LandscapeImageMedia',
      stringKey: 'ImageExperience_Image_Ratio_191x100',
      previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_191x100',
      previewTypeString: _TL_('Landscape image'),
      imagePreviewHeight: 244,
      previewWidth: '600px',
      previewHeight: '244px',
      simplifiedType: 'Image191x100',
      isRequired: true,
      minimumRequirements: 1,
      minSize: [703, 368],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'multimedia-ad-landscape-image',
        showShortHeadline: true,
        showLongHeadline: false,
        showDescription: true,
        showBusinessName: false,
        showUrl: true,
        showAction: true,
        showAdsLabel: true,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
    },
    Image4x1: {
      aspectRatio: 4,
      type: 'Image4x1',
      associationType: 'ImageMedia4x1',
      stringKey: 'ImageExperience_Image_Ratio_4x1',
      previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_4x1',
      previewTypeString: _TL_('Wide image'),
      imagePreviewHeight: 152,
      previewWidth: '608px',
      previewHeight: '152px',
      simplifiedType: 'Image4x1',
      isRequired: true,
      minimumRequirements: 0,
      minSize: [608, 152],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'multimedia-ad-wide-image',
        showShortHeadline: true,
        showLongHeadline: false,
        showDescription: true,
        showBusinessName: false,
        showUrl: true,
        showAction: true,
        showAdsLabel: true,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
    },
    Image1x1: {
      aspectRatio: 1,
      type: 'Image1x1',
      associationType: 'SquareImageMedia',
      stringKey: 'ImageExperience_Image_Ratio_1x1',
      previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_1x1',
      previewTypeString: _TL_('Square image'),
      imagePreviewHeight: 400,
      previewWidth: '400px',
      previewHeight: '400px',
      simplifiedType: 'Image1x1',
      isRequired: true,
      minimumRequirements: 1,
      minSize: [470, 470],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'multimedia-ad-square-image',
        showShortHeadline: true,
        showLongHeadline: false,
        showDescription: true,
        showBusinessName: false,
        showUrl: true,
        showAction: true,
        showAdsLabel: true,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
    },
    Image1x2: {
      aspectRatio: 0.5,
      type: 'Image1x2',
      associationType: 'ImageMedia1x2',
      stringKey: 'ImageExperience_Image_Ratio_1x2',
      previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_1x2',
      previewTypeString: _TL_('Vertical image'),
      imagePreviewHeight: 400,
      previewWidth: '200px',
      previewHeight: '400px',
      simplifiedType: 'Image1x2',
      isRequired: true,
      minimumRequirements: 0,
      minSize: [470, 940],
      maxSize: [0, 0],
      previewSettings: {
        previewContentClassName: 'multimedia-ad-vertical-image',
        showShortHeadline: true,
        showLongHeadline: false,
        showDescription: true,
        showBusinessName: false,
        showUrl: true,
        showAction: true,
        showAdsLabel: true,
        showAdditionalDisclaimer: true,
      },
      isLogo: false,
    },
  };
};

constants.getAspectRatios = ({
  isMultimediaAd,
  isMultimediaAdinMSANEnabled,
  imageOption = constants.defaultImageOption,
  isCombinedMsanAndMmaAspectRatios = false,
  isNewMSANBoostEnabled = false,
  isBoost200x100ImageEnabled = false,
  isBoostNewAspectRatioSupportEnabled = false,
  isMMAV2Enabled = false,
  isDisplayAds = false,
  isPortraitImage = false,
  isStoreAppProng = false,
  isStoreAppSpotLight = false,
  isStoreAppTransparentLogo = false,
  isUnifiedAppCampaignWindowsStore = false,
  isLinkedInAd = false,
  isPMaxAspectRatiosV2Enabled = false,
}) => {
  if (isLinkedInAd) {
    return constants.aspectRatiosForLinkedInAds;
  }
  if (isStoreAppProng) {
    return { ImagePRONG: { ...constants.aspectRatiosForAppCampaign.ImagePRONG } };
  }
  if (isStoreAppSpotLight) {
    return { ImageSPOTLIGHT: { ...constants.aspectRatiosForAppCampaign.ImageSPOTLIGHT } };
  }
  if (isStoreAppTransparentLogo) {
    return { TransparentLogo: { ...constants.aspectRatiosForAppCampaign.TransparentLogo } };
  }

  if (isUnifiedAppCampaignWindowsStore) {
    return { ImagePRONG: { ...constants.aspectRatiosForAppCampaign.ImagePRONG }, ImageSPOTLIGHT: { ...constants.aspectRatiosForAppCampaign.ImageSPOTLIGHT } };
  }
  // old boost portrait uses separate image experience and they pass in isPotraitImage prop.
  // for new boost campaigns in display plus we reuse pmax image experience and for that we need to rely on imageOptionstate.
  if (isPortraitImage || imageOption === constants.imageOptionKeys.Portrait) {
    return constants.aspectRatiosForBoostPortrait;
  }
  if (isDisplayAds) {
    return constants.aspectRatiosForDisplayAds;
  }

  if (imageOption === constants.imageOptionKeys.Logo) {
    return logoAspectRatios;
  }

  if (isCombinedMsanAndMmaAspectRatios) {
    return isPMaxAspectRatiosV2Enabled
      ? constants.pmaxV2Ratios
      : { ..._.pick(constants.aspectRatios, constants.pmaxMsanRatios), ..._.pick(constants.getMmaAspectRatios(), constants.pmaxMmaRatios) };
  }

  let aspectRatios = isMultimediaAd ? constants.getMmaAspectRatios() : constants.aspectRatios;

  if (isMultimediaAdinMSANEnabled) {
    aspectRatios = _.pick(aspectRatios, constants.multimediaAdinMSANRatios);
  }

  if (isNewMSANBoostEnabled) {
    aspectRatios = _.pick(aspectRatios, constants.boostMultimediaAdinMSANRatios);
    _.extend(aspectRatios, constants.aspectRatiosForNewMSANBoost);
    return aspectRatios;
  }

  if (isBoost200x100ImageEnabled || isBoostNewAspectRatioSupportEnabled) {
    _.extend(aspectRatios, constants.aspectRatiosForBoost200x100);

    if (isBoostNewAspectRatioSupportEnabled) {
      _.extend(aspectRatios, constants.aspectRatiosForBoostNewSupport);
    }
  }

  if (isMMAV2Enabled) {
    aspectRatios = _.pick(constants.aspectRatiosForMMAV2, constants.audienceMMAV2AspectRatios);
  }

  return aspectRatios;
};

constants.SupportedCaptionLocales = [
  {
    Lcid: 1033,
    FullName: 'English (US): en_US',
    Tag: 'en_US',
  },
];

constants.LcidToFullName = (Lcid) => {
  const locale = constants.SupportedCaptionLocales.find(loc => loc.Lcid === Lcid);
  return locale ? locale.FullName : Lcid.toString();
};

constants.TagToLcid = (tag) => {
  const locale = constants.SupportedCaptionLocales
    .find(loc => loc.Tag.toLowerCase() === tag.toLowerCase());
  return locale ? locale.Lcid : null;
};

constants.DEFAULT_MAX_IMAGE = 16;
constants.DEFAULT_MAX_LOGO = 5;
constants.DEFAULT_MAX_PORTRAIT = 1;

constants.audienceMMAV2WithDiffAspectRatio = ['Image191x100', 'Image169x100', 'Image1x1'];

constants.multimediaAdinMSANRatios = ['Image191x100', 'Image178x100', 'Image150x100', 'Image133x100', 'Image1x1'];
constants.boostMultimediaAdinMSANRatios= ['Image191x100', 'Image178x100', 'Image150x100', 'Image133x100', 'Image1x1', 'Image57x100', 'Image320x100'];
constants.boostMultimediaAdinMSANRatiosBlacklistForUpload = ['Image57x100', 'Image320x100'];
constants.boostMultimediaAdinMSANRatios200x100 = constants.multimediaAdinMSANRatios.concat('Image200x100');
constants.boostMultimediaAdinMSANRatiosNewSupport = constants.boostMultimediaAdinMSANRatios200x100
  .concat('Image122x100', 'Image159x100', 'Image180x100', 'Image233x100', 'Image320x100', 'Image57x100');
constants.pmaxMsanRatios = ['Image191x100', 'Image178x100', 'Image150x100', 'Image133x100', 'Image1x1'];
constants.pmaxMmaRatios = ['Image4x1', 'Image1x2'];

constants.pmaxV2Ratios = {
  Image191x100: {
    aspectRatio: 1.91,
    type: 'Image191x100',
    associationType: 'LandscapeImageMedia',
    stringKey: 'ImageExperience_Image_Ratio_191x100',
    previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_191x100',
    previewTypeString: _TL_('Landscape image'),
    imagePreviewHeight: 244,
    previewWidth: '600px',
    previewHeight: '244px',
    simplifiedType: 'Image191x100',
    isRequired: true,
    minimumRequirements: 1,
    minSize: [703, 368],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'multimedia-ad-landscape-image',
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: false,
  },
  Image4x1: {
    aspectRatio: 4,
    type: 'Image4x1',
    associationType: 'ImageMedia4x1',
    stringKey: 'ImageExperience_Image_Ratio_4x1',
    previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_4x1',
    previewTypeString: _TL_('Wide image'),
    imagePreviewHeight: 152,
    previewWidth: '608px',
    previewHeight: '152px',
    simplifiedType: 'Image4x1',
    isRequired: true,
    minimumRequirements: 0,
    minSize: [608, 152],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'multimedia-ad-wide-image',
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: false,
  },
  Image1x1: {
    aspectRatio: 1,
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    stringKey: 'ImageExperience_Image_Ratio_1x1',
    previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_1x1',
    previewTypeString: _TL_('Square image'),
    imagePreviewHeight: 400,
    previewWidth: '400px',
    previewHeight: '400px',
    simplifiedType: 'Image1x1',
    isRequired: true,
    minimumRequirements: 1,
    minSize: [470, 470],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'multimedia-ad-square-image',
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: false,
  },
  Image1x2: {
    aspectRatio: 0.5,
    type: 'Image1x2',
    associationType: 'ImageMedia1x2',
    stringKey: 'ImageExperience_Image_Ratio_1x2',
    previewTypeStringKey: 'ImageExperience_Preview_Type_MultimediaAd_1x2',
    previewTypeString: _TL_('Vertical image'),
    imagePreviewHeight: 400,
    previewWidth: '200px',
    previewHeight: '400px',
    simplifiedType: 'Image1x2',
    isRequired: true,
    minimumRequirements: 0,
    minSize: [470, 940],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'multimedia-ad-vertical-image',
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: false,
  },
  Image201x100: {
    aspectRatio: 2.01,
    type: 'Image201x100',
    associationType: 'ImageMedia201X100',
    stringKey: 'ImageExperience_Image_Ratio_201x100',
    previewTypeStringKey: 'ImageExperience_Preview_Type_201x100',
    previewTypeString: _TL_('Microsoft Edge carousel'),
    imagePreviewHeight: 304,
    minimumRequirements: 0,
    minSize: [612, 304],
    previewSettings: {
      previewContentClassName: 'edge-carousel ', // ???
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: false,
  },
  Image169x100: {
    aspectRatio: 1.69,
    type: 'Image169x100',
    associationType: 'ImageMedia169X100',
    stringKey: 'ImageExperience_Image_Ratio_169x100',
    previewTypeStringKey: 'ImageExperience_Preview_Type_169x100_V2',
    previewTypeString: _TL_('MSN Single Carousel'),
    imagePreviewHeight: 372,
    minimumRequirements: 0,
    minSize: [628, 372],
    previewSettings: {
      previewContentClassName: 'msn-single-carousel-v2', // ???
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: false,
  },
  Image153x100: {
    aspectRatio: 1.53,
    type: 'Image153x100',
    associationType: 'ImageMedia153X100',
    stringKey: 'ImageExperience_Image_Ratio_153x100',
    previewTypeStringKey: 'ImageExperience_Preview_Type_153x100',
    previewTypeString: _TL_('MSN partner stripe'),
    imagePreviewHeight: 197,
    minimumRequirements: 0,
    minSize: [306, 200],
    previewSettings: {
      previewContentClassName: 'msn-partner-stripe', // ???
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: false,
  },
  Image124x100: {
    aspectRatio: 1.24,
    type: 'Image124x100',
    associationType: 'ImageMedia124X100',
    stringKey: 'ImageExperience_Image_Ratio_124x100',
    previewTypeStringKey: 'ImageExperience_Preview_Type_124x100',
    previewTypeString: _TL_('MSN Restoday'),
    imagePreviewHeight: 84,
    minimumRequirements: 0,
    minSize: [104, 84],
    previewSettings: {
      previewContentClassName: 'msn-restoday', // ???
      showShortHeadline: true,
      showLongHeadline: false,
      showDescription: true,
      showBusinessName: false,
      showUrl: true,
      showAction: true,
      showAdsLabel: true,
      showAdditionalDisclaimer: true,
    },
    isLogo: false,
  },
};

constants.audienceMMAV2AspectRatiosWithoutOriginalImage =
  ['Image201x100', 'Image200x100', 'Image191x100',
    'Image169x100', 'Image153x100', 'Image124x100', 'Image120x100', 'Image1x1'];

constants.audienceMMAV2AspectRatios =
  ['OriginalImage', constants.audienceMMAV2AspectRatiosWithoutOriginalImage];

constants.imageSources = {
  Website: 'Website',
  WebsiteCarousel: 'WebsiteCarousel',
  Upload: 'Upload',
  Existing: 'Existing',
  Stock: 'Stock',
  AdRecommendation: 'AdRecommendation',
  Social: 'Social',
  AIGenerated: 'AIGenerated',
  Invest: 'Invest',
  BackgroundChangeGenerated: 'BackgroundChangeGenerated',
};

// image asset from MT
constants.sourceTypes = {
  TwitterImported: 'TwitterImported',
  WebsiteImported: 'WebsiteImported',
  UserUploaded: 'UserUploaded',
  AIGenerated: 'AIGenerated',
  BackgroundChangeGenerated: 'BackgroundChangeGenerated',
  AIGeneratedByRecraft: 'AIGeneratedByRecraft',
};

constants.getSourceTypeFromImageSource = (imageSource) => {
  if (imageSource === constants.imageSources.Website || imageSource === constants.imageSources.WebsiteCarousel) {
    return constants.sourceTypes.WebsiteImported;
  }
  if (imageSource === constants.imageSources.Social) {
    return constants.sourceTypes.TwitterImported;
  }
  if (imageSource === constants.imageSources.BackgroundChangeGenerated) {
    return constants.sourceTypes.BackgroundChangeGenerated;
  }

  return undefined;
};

constants.preferenceFlags = {
  MMATeachingBubble: 'WebApp.CampaignUI.ShowAdCreatorEditImageBubble',
  MMAWebsiteImageOptIn: 'WebApp.CampaignUI.MMAWebsiteImageOptIn',
  MMAInMSANTeachingBubble: 'WebApp.CampaignUI.ShowAdCreatorEditImageBubbleInMSAN',
  MMAInMSANWebsiteImageOptIn: 'WebApp.CampaignUI.MMAInMSANWebsiteImageOptIn',
};

constants.imageOptionKeys = {
  Image: 'Image',
  Logo: 'Logo',
  Portrait: 'Portrait',
};

constants.getImageOptions = ({
  i18n = {
    getString: _.noop,
  },
  disableImage = false,
  disableLogo = false,
  disablePortrait = false,
}) => [{
  key: constants.imageOptionKeys.Image,
  text: i18n.getString(`ImageOptionDropdown_${constants.imageOptionKeys.Image}`),
  disabled: disableImage,
}, {
  key: constants.imageOptionKeys.Logo,
  text: i18n.getString(`ImageOptionDropdown_${constants.imageOptionKeys.Logo}`),
  disabled: disableLogo,
}, {
  key: constants.imageOptionKeys.Portrait,
  text: i18n.getString(`ImageOptionDropdown_${constants.imageOptionKeys.Portrait}`),
  disabled: disablePortrait,
}];

constants.defaultImageOption = _.first(constants.getImageOptions({})).key;

constants.getAspectRatioOptions = (i18n = {
  getString: _.noop,
}) => [{
  key: constants.logoSubtypes.SquareLogoMedia,
  labelId: constants.logoSubtypes.SquareLogoMedia,
  text: i18n.getString(`AspectRatioChoiceGroup_${constants.logoSubtypes.SquareLogoMedia}`),
}, {
  key: constants.logoSubtypes.LandscapeLogoMedia,
  labelId: constants.logoSubtypes.LandscapeLogoMedia,
  text: i18n.getString(`AspectRatioChoiceGroup_${constants.logoSubtypes.LandscapeLogoMedia}`),
}];

constants.defaultAspectRatioOption = _.first(constants.getAspectRatioOptions()).key;

constants.getBoostAspectRatios = i18n => ({
  windowsSpotlight: {
    aspectRatio: 1.9,
    type: 'Image191x100',
    associationType: 'LandscapeImageMedia',
    stringKey: 'ImageExperience_Image_Ratio_191x100',
    previewTypeStringKey: i18n.getString(_TL_('Windows Spotlight')),
    previewTypeString: '',
    imagePreviewHeight: 400,
    simplifiedType: 'Image191x100',
    isRequired: true,
    minimumRequirements: 1,
    minSize: [268, 140],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'boost-windows',
      showLongHeadline: true,
      showBusinessName: false,
      multipleLineLongHeadline: true,
      multipleDescription: true,
      showDescription: true,
      hideLabel: true,
      showHotspots: true,
    },
  },
  discoverCard: {
    aspectRatio: 1,
    type: 'Image1x1',
    associationType: 'SquareImageMedia',
    stringKey: 'ImageExperience_Image_Ratio_1x1',
    previewTypeStringKey: i18n.getString(_TL_('Discover card')),
    previewTypeString: _TL_('MSN square image'),
    imagePreviewHeight: 250,
    previewWidth: '200px',
    previewHeight: '200px',
    simplifiedType: 'Image1x1',
    isRequired: true,
    minimumRequirements: 0,
    minSize: [300, 300],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'boost-discover-card',
      showShortHeadline: true,
      showLongHeadline: false,
      showBusinessName: false,
      multipleDescription: true,
      showDescription: true,
      showAction: true,
    },
  },
  startMeno: {
    aspectRatio: 1.75,
    type: 'Image178x100',
    previewTypeString: '',
    previewTypeStringKey: i18n.getString(_TL_('Start Menu')),
    imagePreviewHeight: 160,
    logoHeight: 24,
    isRequired: true,
    minimumRequirements: 1,
    minSize: [280, 160],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'boost-start-menu',
      showLogo: true,
      showShortHeadline: true,
      multipleLineLongHeadline: true,
      showLongHeadline: true,
      showAction: false,
      showBusinessName: false,
      showImage: false,
      showDismiss: true,
    },
  },
  actionCenter: {
    aspectRatio: 1.75,
    type: 'Image178x100',
    previewTypeString: '',
    previewTypeStringKey: i18n.getString(_TL_('Action Center')),
    imagePreviewHeight: 160,
    logoHeight: 48,
    isRequired: true,
    minimumRequirements: 1,
    minSize: [280, 160],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'boost-actionCenter',
      showLogo: true,
      showShortHeadline: true,
      multipleDescription: true,
      showDescription: true,
      showAction: true,
      showBusinessName: false,
      showImage: false,
      showDismiss: true,
    },
  },
  banner: {
    aspectRatio: 1.75,
    type: 'Image178x100',
    previewTypeString: '',
    previewTypeStringKey: i18n.getString(_TL_('Banner')),
    imagePreviewHeight: 160,
    logoHeight: 20,
    isRequired: true,
    minimumRequirements: 1,
    minSize: [280, 160],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'boost-banner',
      showLogo: true,
      showShortHeadline: true,
      showAction: true,
      showBusinessName: false,
      showImage: false,
      showDismiss: true,
    },
  },
  Image191x100: {
    aspectRatio: 1.914,
    type: 'Image191x100',
    associationType: 'LandscapeImageMedia',
    stringKey: 'ImageExperience_Image_Ratio_191x100',
    previewTypeStringKey: i18n.getString(_TL_('Prong 1 / Prong 2 / Feed')),
    previewTypeString: '',
    imagePreviewHeight: 140,
    simplifiedType: 'Image191x100',
    isRequired: true,
    minimumRequirements: 1,
    minSize: [268, 140],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'boost-191X1',
      showBusinessName: true,
      showLongHeadline: true,
      multipleLineLongHeadline: true,
      hideLabel: true,
    },
  },
  coachmark: {
    aspectRatio: 1.75,
    type: 'Image178x100',
    previewTypeString: '',
    previewTypeStringKey: i18n.getString(_TL_('CoachMark')),
    imagePreviewHeight: 160,
    isRequired: true,
    minimumRequirements: 1,
    minSize: [280, 160],
    maxSize: [0, 0],
    previewSettings: {
      previewContentClassName: 'boost-coachmark',
      showDescription: true,
      showShortHeadline: true,
      showBusinessName: false,
      multipleLineLongHeadline: true,
      multipleDescription: true,
      showAction: true,
    },
  },
});

//
// Image expansion/Fitting - Begin
// None/WhitePadding/Blur/Outpainting/SingleColorPadding
constants.ImageExpansionType = UAPImageExpansionType;

constants.CroppingType = UAPCroppingType;
constants.ImageExpansionDataSource = {
  Existing: 'Existing', // the data is loaded from image assets
  ImageFittingAPI: 'ImageFittingAPI', // the data is created by calling image fitting API
};
// Image expansion/Fitting - End

export default constants;
